import {RouteProps} from 'config/navigation';
import Addresses from './addresses';
import CreateAddress from './create-address';
import EditAddress from './edit-address';
import {MdEditLocation} from 'react-icons/md';

const addressesPages: RouteProps = {
  name: 'Endereços',
  path: 'addresses',
  permission: 'addresses.findAll',
  icon: <MdEditLocation />,
  subRoutes: [
    {
      path: '',
      element: <Addresses />,
      permissions: ['addresses.findAll'],
    },
    {
      path: 'create',
      element: <CreateAddress />,
      permissions: ['addresses.create'],
    },
    {
      path: ':id',
      element: <EditAddress />,
      permissions: ['addresses.findOne'],
    },
  ],
};

export default addressesPages;
